module.exports = {
  "hierarchy": {},
  "props": {
    "default": {
      "separatorIcon": "lv lv-chevronRight "
    }
  }
}